// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1yRar","colMin":"styles_colMin__3tbmR"};